<template>
<div
  class="leroy"
  :class="{
    'eyes-half': eyesState === 'half',
    'eyes-closed': eyesState === 'closed'
  }"
>
  <div class="leroy__eyebrows"></div>
  <div class="leroy__eyes">
    <div class="leroy__eyes-open"></div>
    <div class="leroy__eyes-half"></div>
    <div class="leroy__eyes-closed"></div>
  </div>
  <div class="leroy__mouth"></div>
  <div class="leroy__tear" v-if="tear"></div>
</div>
</template>

<script>
export default {
  name: 'leroy',
  props: {
    tear: Boolean
  },
  data () {
    return {
      eyesState: '',
      eyesTimeCounter: 0,
      eyesInterval: null,
      eyesIntervalPeriod: 100
    }
  },
  mounted () {
    clearInterval(this.eyesInterval)
    this.eyesInterval = setInterval(() => {
      if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 50)) {
        this.eyesState = 'half'
        this.eyesTimeCounter += this.eyesIntervalPeriod
      } else if (this.eyesTimeCounter === (this.eyesIntervalPeriod * 51)) {
        this.eyesState = 'closed'
        this.eyesTimeCounter = 0
      } else {
        this.eyesState = ''
        this.eyesTimeCounter += this.eyesIntervalPeriod
      }
    }, this.eyesIntervalPeriod)
  },
  beforeDestroy () {
    clearInterval(this.eyesInterval)
  }
}
</script>

<style lang="scss">
@keyframes eyebrows {
  0% {
    transform: translate3d(0,0%,0);
  }
  10% {
    transform: translate3d(0,0%,0);
  }
  40% {
    transform: translate3d(0,58%,0);
  }
  60% {
    transform: translate3d(0,58%,0);
  }
  90% {
    transform: translate3d(0,0%,0);
  }
  100% {
    transform: translate3d(0,0%,0);
  }
}
@keyframes tear {
  0% {
    opacity: 0;
    transform: translate3d(0,0%,0);
  }
  10% {
    opacity: 1;
    transform: translate3d(0,0%,0);
  }
  70% {
    opacity: 1;
    transform: translate3d(0,556%,0);
  }
  80% {
    opacity: 0;
    transform: translate3d(0,556%,0);
  }
  100% {
    opacity: 0;
    transform: translate3d(0,556%,0);
  }
}
.leroy {
  width: fluid(136px);
  height: fluid(960px);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url('~@/assets/img/leroy-body.svg');
  transform-origin: 0% 0%;
  &__eyebrows {
    position: absolute;
    top: 16%;
    left: 0;
    width: 100%;
    height: fluid(24px);
    margin: 0 0 0 fluid(3px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyebrows.svg');
    animation: eyebrows 7s linear infinite;
  }
  &__mouth {
    position: absolute;
    top: 33%;
    left: 0;
    width: 100%;
    height: fluid(14px);
    margin: 0 0 0 fluid(6px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-frown.svg');
  }
  &__tear {
    position: absolute;
    top: 29%;
    right: 25%;
    width: fluid(8px);
    height: fluid(18px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/water-drop.svg');
    animation: tear 4s linear infinite;
  }
  &__eyes {
    position: absolute;
    top: 21%;
    left: 0;
    width: 100%;
    margin: 0 0 0 fluid(4px);
  }
  &__eyes-open {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: fluid(89px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-open.svg');
  }
  &__eyes-half {
    display: none;
    position: absolute;
    top: fluid(25px);
    left: 0;
    width: 100%;
    height: fluid(65px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-half.svg');
  }
  &__eyes-closed {
    display: none;
    position: absolute;
    top: fluid(35px);
    left: 0;
    width: 100%;
    height: fluid(38px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('~@/assets/img/leroy-eyes-closed.svg');
  }
  &.eyes-half {
    .leroy {
      &__eyes-open {
        display: none;
      }
      &__eyes-half {
        display: block;
      }
    }
  }
  &.eyes-closed {
    .leroy {
      &__eyes-open {
        display: none;
      }
      &__eyes-closed {
        display: block;
      }
    }
  }
}
</style>